import { useState } from "react";
import { C, FONT } from "../theme";

export type Lang = "curl" | "js" | "py";

const LABELS: Record<Lang, string> = { curl: "curl", js: "javascript", py: "python" };

export function CodeTabs({
  snippets,
  compact,
}: {
  snippets: Record<Lang, string>;
  compact?: boolean;
}) {
  const [tab, setTab] = useState<Lang>("curl");
  const langs: Lang[] = ["curl", "js", "py"];

  const tabStyle = (active: boolean): React.CSSProperties => ({
    background: active ? C.inset : "transparent",
    border: "none",
    borderBottom: active ? `2px solid ${C.ac}` : "2px solid transparent",
    color: active ? C.textBright : C.muted,
    padding: compact ? "9px 14px" : "11px 18px",
    font: `600 ${compact ? 12 : 13}px ${FONT}`,
    cursor: "pointer",
  });

  return (
    <div
      style={{
        background: compact ? C.inset : C.panel,
        border: `1px solid ${C.line}`,
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <div style={{ display: "flex", borderBottom: `1px solid ${C.line}` }}>
        {langs.map((l) => (
          <button key={l} onClick={() => setTab(l)} style={tabStyle(tab === l)}>
            {compact ? (l === "js" ? "js" : l) : LABELS[l]}
          </button>
        ))}
      </div>
      <div
        style={{
          padding: compact ? "16px 18px" : "22px 24px",
          fontSize: compact ? 12 : 13,
          lineHeight: 1.85,
          color: C.text,
          overflow: "auto",
        }}
      >
        <pre style={{ margin: 0, fontFamily: "inherit", whiteSpace: "pre-wrap" }}>
          {snippets[tab]}
        </pre>
      </div>
    </div>
  );
}
